// extracted by mini-css-extract-plugin
export default {"myModal":"ModalWindwow_myModal__hF1Ld","myModalContent":"ModalWindwow_myModalContent__8I94+","active":"ModalWindwow_active__0SxnN","closeButton":"ModalWindwow_closeButton__cQKpk"};